import React from 'react';
import moment from 'moment-jalaali';
import StringHelper from '../../src/components/helpers/StringHelper';
import { usePersistedStore } from '../store/persisted-store';
const Profile = () => {

    const { auth } = usePersistedStore();

    const userInfo = auth.userInfo;
    return (
        <div className="main-content profile">
            <div className="page-content">
                <div className="row" style={{ display: "flex" }}>
                    <div className="col-md-12 col-xl-3">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title mb-3">اطلاعات شخصی</h5>
                                <div className="mt-3">
                                    <p className="font-size-12 text-muted mb-1">نام نمایشی</p>
                                    <h6 className="primary-font">{userInfo.DisplayName}</h6>
                                </div>
                                <div className="mt-3">
                                    <p className="font-size-12 text-muted mb-1">کد ملی</p>
                                    <h6 className="primary-font">{userInfo.NationalCode}</h6>
                                </div>
                                <div className="mt-3">
                                    <p className="font-size-12 text-muted mb-1">شماره تماس</p>
                                    <h6 className="primary-font"><span className="ltr-text">{userInfo.Phone}</span></h6>
                                </div>

                                <div className="mt-3">
                                    <p className="font-size-12 text-muted mb-1">پست الکترونیکی</p>
                                    <h6 className="primary-font">{userInfo.Email}</h6>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-xl-9">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title mb-4">اطلاعات کاربری</h4>

                                <div className="table-responsive">
                                    <table className="table table-centered mb-0">
                                        <tbody>
                                            <tr>
                                                <td>سازمان</td>
                                                <td>
                                                    {userInfo.BusinessName}
                                                </td>
                                                <td>نام کاربری</td>
                                                <td>{userInfo.UserName}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    تاریخ عضویت
                                                </td>
                                                <td>{StringHelper.getFarsiNum(moment(userInfo.RegisterDate).format('jYYYY/jMM/jDD'))}</td>
                                                <td>آخرین ورود</td>
                                                <td>{StringHelper.getFarsiNum(moment(userInfo.LastLogin).format('HH:mm jYYYY/jMM/jDD'))}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Profile;